import { Injectable } from '@angular/core';
import { endpoints } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BaseResult } from '../../shared/models/base.result.model';
import { Requisicao } from './models/requisicao.model';
import { Motivo } from './models/motivos.model';

@Injectable()
export class CloseAccountService {
	private url = endpoints.closeAccount;
	private request: Requisicao;

	constructor(private http: HttpClient) { }

	getTerms(): Observable<BaseResult<string>> {
		return this.http.get<BaseResult<string>>(this.url.terms);
	}

	getResolution(): Observable<BaseResult<string>> {
		return this.http.get<BaseResult<string>>(this.url.resolution);
	}

	getReasons(): Observable<BaseResult<Motivo[]>> {
		return this.http.get<BaseResult<Motivo[]>>(this.url.reasons);
	}

	getStatus(): Observable<BaseResult<any>> {
		return this.http.get<BaseResult<any>>(this.url.situation);
	}

	postRequest(request: Requisicao): Observable<BaseResult<any>> {
	 	return this.http.post<BaseResult<any>>(`${this.url.request}`, request);
	}

	createRequest(nomeBancoDestino: string, codAgenciaDestino: string, codContaDestino: string, motivo: string[]) {
		this.request = {
			nomeBancoDestino: nomeBancoDestino,
			codAgenciaDestino: codAgenciaDestino,
			codContaDestino: codContaDestino,
			motivo: motivo,
		};
	}

	getCreatedRequest = () => this.request;


}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/close-account/close-account.service.ts